<!--
 * @Author: LiuMeiYu
 * @Date: 2022-12-26 10:33:32
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-05-24 14:13:52
 * @FilePath: \nivara\src\views\home\homeView.vue
 * @Description: *
 * *
 * Copyright (c) 2022 by yihua, All Rights Reserved.
-->
<template>
  <div class="home-container">
    <div class="home-content">
      <div class="home-banner">
        <div class="header-container">
          <div class="header-content">
            <div class="header-logo">
              CardSwap
            </div>
            <div class="header-menu">
              <div class="header-menu-item">
                <el-dropdown trigger="click">
                  <span class="el-dropdown-link">
                    Home<el-icon class="el-icon--right"><arrow-down /></el-icon>
                  </span>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item
                        @click="$router.push({ path: '/demandList' })"
                        >All Offers</el-dropdown-item
                      >
                      <el-dropdown-item
                        @click="$router.push({ path: '/orderList' })"
                        >Order</el-dropdown-item
                      >
                      <el-dropdown-item @click="$router.push({ path: '/chat' })"
                        >Chat</el-dropdown-item
                      >
                      <el-dropdown-item
                        @click="$router.push({ path: '/account' })"
                        >Account</el-dropdown-item
                      >
                      <el-dropdown-item @click="$router.push({ path: '/set' })"
                        >Setting</el-dropdown-item
                      >
                      <el-dropdown-item
                        @click="$router.push({ path: '/wallet' })"
                        >Wallet</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </div>
            </div>
            <div class="header-avatar-msg" v-if="isLogin">
              <div class="header-avatar-info">
                <el-dropdown>
                  <el-image
                    class="header-avatar"
                    :src="
                      userInfoData.avatar ||
                        require('../../assets/images/default_avatar.png')
                    "
                  />
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item @click="logout"
                        >log out</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
                <div class="header-userinfo">
                  <router-link to="/account">
                    <div class="header-userinfo-name">
                      {{ userInfoData.nickname }}
                    </div>
                  </router-link>
                  <div class="header-userinfo-amount">
                    {{ userBalance.withdraw_amount }}
                    {{ userBalance.currency_name }}
                  </div>
                </div>
              </div>
              <el-badge
                class="header-msg"
                :value="unreadMsgTotal"
                :max="99"
                type="danger"
                :hidden="!unreadMsgTotal"
              >
                <router-link to="/chat">
                  <el-icon :size="40"><ChatRound /></el-icon>
                </router-link>
              </el-badge>
            </div>
            <div class="header-login-register" v-else>
              <router-link to="/login">
                <div class="header-btn-login">Log in</div>
              </router-link>
              <router-link to="/register">
                <div class="header-btn-register">Register</div>
              </router-link>
            </div>
          </div>
        </div>
        <h1>Trade Gift card with CardSwap</h1>
        <p>
          Join the leading peer-to-peer platform to buy and sell Gift card
          <br />
          using 350+ payment methods with 10 million people just like you.
        </p>
        <div class="home-sell-buy">
          <el-tabs
            v-model="homeTabsActive"
            class="home-tabs"
            type="card"
            @tab-click="homeTabsClick"
          >
            <el-tab-pane label="SELL" name="sell">
              <el-form
                class="home-sell-form"
                label-position="top"
                label-width="100px"
                :model="homeSellFormData"
              >
                <el-form-item label="Gift Card">
                  <el-select
                    v-model="homeSellFormData.giftcard"
                    placeholder="please select your gift card"
                    style="width: 100%;"
                    @change="sellRateChange"
                    v-loading="getDemandListByCurrencyLoading"
                  >
                    <el-option
                      v-for="(item, index) in homeSellFormData.categoryList"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="Ammount">
                      <el-input
                        v-model="homeSellFormData.ammount"
                        placeholder="Please enter amount"
                        @input="sellAmountInput"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Currency">
                      <el-select
                        v-model="homeSellFormData.currency"
                        placeholder="please select your currency"
                        style="width: 100%;"
                        @change="sellCurrencyChange"
                        v-loading="getDemandListLoading"
                      >
                        <el-option
                          v-for="(item, index) in homeSellFormData.currencyList"
                          :key="index"
                          :label="item"
                          :value="item"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item>
                  <div class="home-sell-result">
                    <div class="home-sell-price-currency">
                      <span class="home-sell-price-currency-name">The Highest Price</span>
                      <el-select
                        v-model="homeSellResultCurrency"
                        @change="sellCountryChange"
                        v-loading="getCountryListLoading"
                      >
                        <el-option
                          v-for="item in countryListData"
                          :key="item.id"
                          :label="item.short_name"
                          :value="item.id"
                        />
                      </el-select>
                    </div>
                    <div class="home-sell-price-count">
                      <span class="sell-price-count"
                        >≈{{ homeSellResult }}</span
                      >
                      {{ currencySymbol }}
                    </div>
                  </div>
                </el-form-item>
              </el-form>
              <router-link to="/demandList">
                <el-button class="go-find-offer">
                  Go find the offer
                </el-button>
              </router-link>
            </el-tab-pane>
            <el-tab-pane label="BUY" name="buy">No Data</el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="home-statistics">
        <div class="title">
          Easy and fast transaction
        </div>
        <div class="desc">
          Buy and sell with people around the world Just like you using your
          <br />
          owın prices and payment methods.
        </div>
        <div class="statistics-list">
          <div class="statistics-item">
            <el-image
              :src="require('../../assets/images/statistics_icon_01.png')"
              alt=""
            />
            <div class="count-name">
              <span class="count">12,000+</span>
              <span>Active offers</span>
            </div>
          </div>
          <div class="statistics-item">
            <el-image
              :src="require('../../assets/images/statistics_icon_02.png')"
              alt=""
            />
            <div class="count-name">
              <span class="count">12,000+</span>
              <span>Verified sellers</span>
            </div>
          </div>
          <div class="statistics-item">
            <el-image
              :src="require('../../assets/images/statistics_icon_03.png')"
              alt=""
            />
            <div class="count-name">
              <span class="count">6,000,000+</span>
              <span>Users around the world</span>
            </div>
          </div>
        </div>
        <router-link to="/demandList">
          <el-button class="btn-start-trading" size="large"
            >Start Trading</el-button
          >
        </router-link>
      </div>
      <div class="home-testimonials">
        <div class="title">Testimonials</div>
        <div class="desc">
          Wondering what our users think about using CardSwap?
          <br />Let themtell vou in their own words
        </div>
        <div class="testimonials-list">
          <el-carousel :interval="4000" type="card">
            <el-carousel-item
              v-for="(item, index) in testimonialsList"
              :key="index"
            >
              <img class="testimonials-avatar" :src="item.avatar" alt="" />
              <div class="testimonials-content">
                {{ item.text }}
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import {
  defineComponent,
  reactive,
  onMounted,
  ref,
  toRefs,
  nextTick,
} from "@vue/runtime-core";
import Footer from "../../components/FooterView.vue";
import {
  getUserInfoApi,
  getUserBalanceApi,
  getDemandListApi,
  getCountryListApi,
} from "../../api/index";
import { getChatListApi } from "../../api/chat";
import { useRouter } from "vue-router";
import { ElNotification } from "element-plus";

export default defineComponent({
  name: "Home",
  components: {
    Footer,
  },
  setup() {
    onMounted(() => {
      if (localStorage.getItem("token")) {
        getUserInfo();
        getUserBalance();
        getChatList();
        getCountryList();
      } else {
        console.log("未登录");
        getDemandList();
        getCountryList();
      }
    });
    const countryId = ref("");
    const currencySymbol = ref("");
    const state = reactive({
      homeSellFormData: {
        giftcard: "",
        rate: "",
        categoryList: [],
        ammount: "",
        currency: "",
        currencyList: [],
      },
      countryListData: [],
      userInfoData: {},
      userBalance: {},
    });
    const router = useRouter();
    const testimonialsList = reactive([
      {
        avatar: require("../../assets/images/avatar_01.png"),
        text:
          "I love CardSwap. They have the best rates. I am happy to be part of CardSwap user.",
      },
      {
        avatar: require("../../assets/images/avatar_02.webp"),
        text:
          "After I traded a gift card and got paid within 5 minutes, I am sure I will be with CardSwap forever.",
      },
      {
        avatar: require("../../assets/images/avatar_03.webp"),
        text:
          "I’d love to recommend CardSwap to you. Because when I had a withdrawal issues, they dealt with it immediately.",
      },
      {
        avatar: require("../../assets/images/avatar_04.webp"),
        text: "You guys are amazing! Keep up with good works.",
      },
      {
        avatar: require("../../assets/images/avatar_05.webp"),
        text:
          "Great. When I have issues, they respond very quickly and politely.",
      },
      {
        avatar: require("../../assets/images/avatar_06.webp"),
        text:
          "It is a good app to trade gift cards. I will keep using it because I find a honest buyer on it.",
      },
    ]);
    const homeTabsActive = ref("sell");

    const homeSellResultCurrency = ref("");
    const homeSellResult = ref(0);
    const isLogin = ref(false);

    const homeTabsClick = (e) => {
      if (e.paneName == "sell") {
        demandType.value = 1;
        nextTick(() => {
          getDemandList();
        });
      } else {
        demandType.value = 2;
        nextTick(() => {
          getDemandList();
        });
      }
    };

    // 售卡汇率变更
    const sellRateChange = (e) => {
      let index = state.homeSellFormData.categoryList.findIndex(
        (item) => item.id === e
      );
      state.homeSellFormData.rate =
        state.homeSellFormData.categoryList[index].rate;
      sellCalculation();
    };

    // 货币变更
    const sellCurrencyChange = (e) => {
      state.homeSellFormData.currency = e;
      nextTick(() => {
        getDemandListByCurrency();
      });
    };

    // 国家变更
    const sellCountryChange = (e) => {
      let index = state.countryListData.findIndex((item) => item.id === e);
      currencySymbol.value = state.countryListData[index].currency_symbol;
      countryId.value = e;
      nextTick(() => {
        getDemandListByCurrency();
      });
    };

    // 金额变更
    const sellAmountInput = () => {
      sellCalculation();
    };

    // 出售计算
    const sellCalculation = () => {
      homeSellResult.value = (
        state.homeSellFormData.rate * state.homeSellFormData.ammount
      ).toFixed(2);
    };

    const getUserInfo = () => {
      let data = {
        token: localStorage.getItem("token"),
      };
      getUserInfoApi(data).then((res) => {
        console.log("getUserInfoApi：", res);
        if (res.data.data) {
          localStorage.setItem("userInfo", JSON.stringify(res.data.data));
          state.userInfoData = res.data.data;
          countryId.value = res.data.data.country_id;
          isLogin.value = true;
          nextTick(() => {
            getDemandList();
          });
        } else {
          isLogin.value = false;
        }
      });
    };
    const getUserBalance = () => {
      let data = {
        token: localStorage.getItem("token"),
      };
      getUserBalanceApi(data).then((res) => {
        // console.log(res);
        if (res.data.data) {
          state.userBalance = res.data.data;
        }
      });
    };
    let unreadMsgTotal = ref(0);
    // 获取聊天列表遍历未读消息数量 相加起来
    const getChatList = () => {
      let params = {
        token: localStorage.getItem("token"),
      };
      getChatListApi(params).then((res) => {
        console.log(res);
        if (res.data.length) {
          res.data.forEach((element) => {
            unreadMsgTotal.value += element.unread_num;
          });
        }
      });
    };
    const demandType = ref(1);
    const getDemandListLoading = ref(false);
    // 获取需求列表
    const getDemandList = () => {
      let data = {
        type: demandType.value,
        country_id: countryId.value,
        currency: state.homeSellFormData.currency,
        calculation: 1,
      };
      getDemandListApi(data).then((res) => {
        console.log("getDemandListApi：", res);
        getDemandListLoading.value = true;
        if (res.data.success) {
          if (res.data.data.currency_list.length > 0) {
            state.homeSellFormData.currency = res.data.data.currency_list[0];
            getDemandListByCurrency();
          }
          getDemandListLoading.value = false;
        } else {
          ElNotification({
            title: "Tips",
            message: res.msg,
            type: "error",
          });
          getDemandListLoading.value = false;
        }
      });
    };
    const getDemandListByCurrencyLoading = ref(false);
    // 获取需求列表根据货币
    const getDemandListByCurrency = () => {
      getDemandListByCurrencyLoading.value = true;
      let data = {
        type: demandType.value,
        country_id: countryId.value,
        currency: state.homeSellFormData.currency,
        calculation: 1,
      };
      getDemandListApi(data).then((res) => {
        console.log("getDemandListByCurrency", res);
        if (res.data.success) {
          if (res.data.data.category_rate.length > 0) {
            state.homeSellFormData.categoryList = res.data.data.category_rate;
            state.homeSellFormData.giftcard = res.data.data.category_rate[0].id;
            state.homeSellFormData.rate = res.data.data.category_rate[0].rate;
          }
          if (res.data.data.currency_list.length > 0) {
            state.homeSellFormData.currencyList = res.data.data.currency_list;
          }
          setTimeout(() => {
            sellCalculation();
          }, 100);
          getDemandListByCurrencyLoading.value = false;
        } else {
          ElNotification({
            title: "Tips",
            message: res.msg,
            type: "error",
          });
          getDemandListByCurrencyLoading.value = false;
        }
      });
    };
    const getCountryListLoading = ref(false);
    // 获取国家列表
    const getCountryList = () => {
      getCountryListApi().then((res) => {
        console.log("getCountryListApi", res);
        getCountryListLoading.value = true;
        if (res.data.success) {
          if (res.data.data.length > 0) {
            state.countryListData = res.data.data;
            homeSellResultCurrency.value = res.data.data[0].id;
            currencySymbol.value = res.data.data[0].currency_symbol;
          }
          getCountryListLoading.value = false;
        } else {
          ElNotification({
            title: "Tips",
            message: res.msg,
            type: "error",
          });
          getCountryListLoading.value = false;
        }
      });
    };
    const logout = () => {
      localStorage.removeItem("token");
      localStorage.removeItem("country_id");
      localStorage.removeItem("currency_name");
      localStorage.removeItem("userId");
      localStorage.removeItem("userInfo");
      nextTick(() => {
        router.push({
          path: "/login",
        });
      });
    };
    return {
      testimonialsList,
      homeTabsActive,
      homeSellResultCurrency,
      currencySymbol,
      homeSellResult,
      isLogin,
      unreadMsgTotal,
      homeTabsClick,
      sellRateChange,
      sellCurrencyChange,
      sellCountryChange,
      sellAmountInput,
      getDemandListLoading,
      getDemandListByCurrencyLoading,
      getCountryListLoading,
      logout,
      ...toRefs(state),
    };
  },
});
</script>

<style lang="less" scoped>
.home-container {
  .home-content {
    .home-banner {
      position: relative;
      width: 100%;
      padding-top: 80px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-image: url("../../assets/images/home_top_bg.png");
      background-repeat: no-repeat;
      background-position: left top;
      background-size: 100% 100%;
      color: #ffffff;
      z-index: 2;
      .header-container {
        position: absolute;
        width: 100%;
        height: 80px;
        top: 0;
        left: 0;
        .header-content {
          height: 100%;
          margin: 0 100px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #ffffff;
          .header-logo {
            font-size: 20px;
            font-weight: 500;
          }
          .header-menu {
            .header-menu-item {
              .el-dropdown-link {
                cursor: pointer;
                display: flex;
                align-items: center;
                color: #ffffff;
              }
            }
          }
          .header-login-register {
            display: flex;
            align-items: center;
            .header-btn-login {
              margin-right: 40px;
            }
            .header-btn-register {
              padding: 10px 25px;
              border-radius: 10px;
              background-color: #03004d;
              cursor: pointer;
            }
            a {
              color: #ffffff;
            }
          }
          .header-avatar-msg {
            display: flex;
            align-items: center;
            .header-avatar-info {
              display: flex;
              align-items: center;
              .header-avatar {
                width: 46px;
                height: 46px;
                border-radius: 50%;
                cursor: pointer;
              }
              .header-userinfo {
                display: flex;
                flex-direction: column;
                a {
                  color: #ffffff;
                }

                .header-userinfo-amount {
                  color: #fdbc2a;
                }
              }
            }
            .header-msg {
              margin-left: 20px;
              a {
                color: #ffffff;
              }
            }
          }
        }
      }
      h1 {
        margin-top: 40px;
        font-size: 60px;
      }
      p {
        margin-top: 20px;
        line-height: 24px;
        z-index: 2;
      }
      .home-sell-buy {
        width: 832px;
        min-width: 832px;
        margin-top: 60px;
        margin-bottom: 60px;
        padding: 30px 64px;
        background-color: #ffffff;
        color: #000000;
        border-radius: 12px;
        .home-tabs {
          a {
            color: #ffffff;
          }
          :deep(.el-tabs__header) {
            display: flex;
            justify-content: center;
            border: none;
          }
          :deep(.el-tabs__nav) {
            position: relative;
            width: 200px;
            display: flex;
            border: none;
            border-radius: 10px;
            overflow: hidden;
          }
          :deep(.el-tabs__item) {
            flex: 1;
            border: none;
            background-color: #efefef;
          }
          :deep(.el-tabs__item.is-active) {
            border: none;
            background-color: #03034d;
            color: #ffffff;
          }
          :deep(.el-form-item) {
            margin-bottom: 10px;
          }
          :deep(.el-form-item__label) {
            padding: 0;
            color: #000000;
          }
        }
        .home-sell-result {
          .home-sell-price-currency {
            display: flex;
            justify-content: space-between;
            .home-sell-price-currency-name {
              flex: 1;
              text-align: left;
            }
            .el-select {
              width: 130px;
              :deep(.el-input__inner) {
                border: none;
              }
            }
          }
          .home-sell-price-count {
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 12px;
            border: 1px solid #dfdfdf;
            .sell-price-count {
              font-size: 34px;
            }
          }
        }
        .go-find-offer {
          height: 60px;
          margin-top: 40px;
          margin-bottom: 10px;
          padding-left: 50px;
          padding-right: 50px;
          background-color: #03004d;
          border-radius: 10px;
          font-size: 18px;
          color: #ffffff;
          a {
            color: #ffffff;
          }
        }
      }
    }
    .home-statistics {
      padding: 100px 0;
      a {
        color: #ffffff;
      }
      .title {
        position: relative;
        font-size: 44px;
        font-weight: bold;
        &::before {
          content: " ";
          position: absolute;
          width: 6%;
          height: 8px;
          left: 47%;
          bottom: 8px;
          background-color: #f9df99;
          z-index: -1;
        }
      }
      .desc {
        margin-top: 40px;
        color: #acacac;
      }
      .statistics-list {
        margin-top: 50px;
        padding: 0 100px;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        flex-wrap: wrap;
        .statistics-item {
          width: 24%;
          padding: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 0 8px #fafafa;
          .el-image {
            width: 80px;
            min-width: 80px;
            height: 80px;
            min-height: 80px;
          }
          .count-name {
            margin-left: 20px;
            display: flex;
            flex-direction: column;

            .count {
              font-size: 48px;
            }
          }
        }
      }
      .btn-start-trading {
        height: 60px;
        margin-top: 80px;
        margin-bottom: 10px;
        padding-left: 50px;
        padding-right: 50px;
        background-color: #03004d;
        border-radius: 10px;
        font-size: 18px;
        color: #ffffff;
      }
    }
    .home-testimonials {
      padding: 100px 0;
      .title {
        position: relative;
        font-size: 44px;
        font-weight: bold;
        &::before {
          content: " ";
          position: absolute;
          width: 6%;
          height: 8px;
          left: 47%;
          bottom: 8px;
          background-color: #f9df99;
          z-index: -1;
        }
      }
      .desc {
        margin-top: 40px;
        color: #acacac;
      }
      .testimonials-list {
        margin-top: 50px;
        padding: 0 100px;
      }
    }
  }

  .el-carousel__item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #99a9bf;

    .testimonials-avatar {
      width: 60px;
      height: 60px;
      border-radius: 50%;
    }

    .testimonials-content {
      margin-top: 20px;
      padding: 0 100px;
    }
  }

  .el-carousel__item.is-active {
    background-color: #d3dce6;
  }
}
</style>
